"use strict";
exports.__esModule = true;
exports.convertToQueryString = function (params) {
    return '?' +
        Object.entries(params)
            .map(function (_a) {
            var key = _a[0], value = _a[1];
            return encodeURIComponent(key) + "=" + encodeURIComponent("" + value);
        })
            .join('&');
};
//# sourceMappingURL=convert-to-query-string.js.map